// ---------------------------------------------------------------------------
// Telemetry-free crash log. On desktop, errors are appended to a small rotating
// file in the app-data dir (logs/app.log) via the Rust `log_message` command,
// so "it broke" comes with something to read. On the web build it's console-only.
// ---------------------------------------------------------------------------

import { invoke, isTauri } from '../ai/tauri';

export function logToFile(level: 'info' | 'warn' | 'error', message: string): void {
  if (!isTauri()) return;
  const line = `${new Date().toISOString()} ${message}`.slice(0, 4000);
  void invoke('log_message', { level, message: line }).catch(() => {});
}

let installed = false;

/** Route uncaught errors and unhandled rejections into the crash log. */
export function installGlobalErrorLogging(): void {
  if (installed || typeof window === 'undefined') return;
  installed = true;
  window.addEventListener('error', (e) => {
    logToFile('error', `Uncaught: ${e.message} @ ${e.filename}:${e.lineno}`);
  });
  window.addEventListener('unhandledrejection', (e) => {
    const reason = e.reason instanceof Error ? `${e.reason.message}\n${e.reason.stack ?? ''}` : String(e.reason);
    logToFile('error', `Unhandled rejection: ${reason}`);
  });
}
